import { Box, Flex, Heading, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  eyebrow?: ReactNode;
  icon?: ReactElement;
  actions?: ReactNode;
  align?: 'start' | 'center';
}

export function PageHeader({
  title,
  description,
  eyebrow,
  icon,
  actions,
  align = 'start',
}: PageHeaderProps) {
  const isCentered = align === 'center';

  return (
    <Flex
      align={isCentered ? 'center' : { base: 'stretch', md: 'flex-start' }}
      justify="space-between"
      direction={{ base: 'column', md: isCentered ? 'column' : 'row' }}
      gap="4"
      textAlign={isCentered ? 'center' : 'left'}
    >
      <HStack
        gap="3"
        align={isCentered ? 'center' : 'flex-start'}
        justify={isCentered ? 'center' : 'flex-start'}
      >
        {icon ? (
          <Box layerStyle="iconTile" boxSize="9" flexShrink={0}>
            <Icon boxSize="4.5">{icon}</Icon>
          </Box>
        ) : null}
        <VStack align={isCentered ? 'center' : 'start'} gap="1.5" minW={0}>
          {eyebrow ? <Text textStyle="sectionLabel">{eyebrow}</Text> : null}
          <Heading
            as="h1"
            size="lg"
            color="ui.text.primary"
            lineHeight="1.15"
            letterSpacing="-0.02em"
            textWrap="balance"
          >
            {title}
          </Heading>
          {description ? (
            <Text
              fontSize="sm"
              color="ui.text.secondary"
              maxW="3xl"
              lineHeight="1.55"
              textWrap="pretty"
            >
              {description}
            </Text>
          ) : null}
        </VStack>
      </HStack>

      {actions ? (
        <Box flexShrink={0} w={{ base: 'full', md: 'auto' }}>
          {actions}
        </Box>
      ) : null}
    </Flex>
  );
}
